export default __webpack_public_path__ + "static/media/pirate-ship-3.5281058b.png";